/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { NotificationPreferenceDeliveryScopeType } from './NotificationPreferenceDeliveryScopeType';
import {
    NotificationPreferenceDeliveryScopeTypeFromJSON,
    NotificationPreferenceDeliveryScopeTypeFromJSONTyped,
    NotificationPreferenceDeliveryScopeTypeToJSON,
} from './NotificationPreferenceDeliveryScopeType';

/**
 * 
 * @export
 * @interface NotificationPreferenceSettingDeliveryScope
 */
export interface NotificationPreferenceSettingDeliveryScope {
    /**
     * 
     * @type {NotificationPreferenceDeliveryScopeType}
     * @memberof NotificationPreferenceSettingDeliveryScope
     */
    scope?: NotificationPreferenceDeliveryScopeType;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationPreferenceSettingDeliveryScope
     */
    enabled?: boolean;
}

/**
 * Check if a given object implements the NotificationPreferenceSettingDeliveryScope interface.
 */
export function instanceOfNotificationPreferenceSettingDeliveryScope(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function NotificationPreferenceSettingDeliveryScopeFromJSON(json: any): NotificationPreferenceSettingDeliveryScope {
    return NotificationPreferenceSettingDeliveryScopeFromJSONTyped(json, false);
}

export function NotificationPreferenceSettingDeliveryScopeFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationPreferenceSettingDeliveryScope {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'scope': !exists(json, 'scope') ? undefined : NotificationPreferenceDeliveryScopeTypeFromJSON(json['scope']),
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
    };
}

export function NotificationPreferenceSettingDeliveryScopeToJSON(value?: NotificationPreferenceSettingDeliveryScope | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'scope': NotificationPreferenceDeliveryScopeTypeToJSON(value.scope),
        'enabled': value.enabled,
    };
}

